import Grid from '@material-ui/core/Grid';
import AnalysisConditionsTable from 'pages/Evaluation/Product/ScenariosManagement/AnalysisConditionsTable';
import AnalysisDescriptorsTable from 'pages/Evaluation/Product/ScenariosManagement/AnalysisDescriptorsTable';
import Conditions from 'pages/Evaluation/Product/ScenariosManagement/ConditionsTable';
import Descriptors from 'pages/Evaluation/Product/ScenariosManagement/DescriptorsTable';
import React, { useState } from 'react';
import { ERC } from 'utils/constants/descriptorTypes';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(0);

const Component = props => {
  const { augmentedConditionsByDescriptorId, augmentedDescriptors, lcs, scenario, productId } = props;

  const [descriptorId, setDescriptorId] = useState(null);
  const [analysisDescriptorId, setAnalysisDescriptorId] = useState(null);

  return (
    <Grid container>
      <Grid item xs={7}>
        <Descriptors
          descriptorId={descriptorId}
          setDescriptorId={setDescriptorId}
          descriptorFilter={ERC}
          scenario={scenario}
          productId={productId}
          lcs={lcs}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid item xs={5}>
        <AnalysisDescriptorsTable
          augmentedDescriptors={augmentedDescriptors}
          descriptorId={analysisDescriptorId}
          setDescriptorId={setAnalysisDescriptorId}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid item xs={7}>
        <Conditions
          descriptorFilter={ERC}
          descriptorId={descriptorId}
          conditionsFilter={'Ambiente'}
          scenario={scenario}
        />
      </Grid>
      <Grid item xs={5}>
        <AnalysisConditionsTable
          descriptorId={analysisDescriptorId}
          augmentedConditionsByDescriptorId={augmentedConditionsByDescriptorId}
        />
      </Grid>
    </Grid>
  )
};

export default Component;
